export function getProductTypes() {
    return [
        { value: 'product', label:'Towar' },
        { value: 'service', label:'Usługa' },
    ];
}

export function getLabelForProductType(id) {
    return getProductTypes().find((x) => x.value === id)?.label;
}